import React from 'react';
import { Helmet } from 'react-helmet';
import OptinTemplate from '../../templates/optintemplate/OptinTemplate';
import OptinAlreadyTemplate from '../../templates/optinalreadytemplate/OptinAlreadyTemplate';
import OptinLandingPressedTemplate from '../../templates/optinlandingpressedtemplate/OptinLandingPressedTemplate';
import OptoutAlreadyTemplate from '../../templates/optoutalreadytemplate/OptoutAlreadyTemplate';
import OptoutTemplate from '../../templates/optouttemplate/OptoutTemplate';
import OptoutConfirmationTemplate from '../../templates/optoutconfirmationtemplate/OptoutConfirmationTemplate';
import ErrorTemplate from '../../templates/errortemplate/ErrorTemplate';
import {hideProgressMessage, showProgressMessage} from '../../js/splashscreen';
import email from '../email';
import OptinConfirmationPage from "../../templates/optinconfirmationtemplate/OptinConfirmationTemplate";


var ES6Promise = require('es6-promise');
ES6Promise.polyfill();
var axios = require('axios');

class OptinLanding extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: null,
      detail: null
    };

    this.sendData = this.sendData.bind(this);
  }

  componentDidMount() {
    this.getIO();
  }

  getIO() {
    const urlParams = new URLSearchParams(this.props.location.search);
    var key = urlParams.get('info');
    key = key !== null ? key : '';
    axios.get(process.env.REACT_APP_BACKEND_URL + 'api/v1/io', {
      params: {
        info: key
      }
    })
      .then((response) => {
        this.setState({
          page: response.data.landing,
          detail: response.data.responseParameter
        });
      })
      .catch((err) => {
        this.setState({
          page: 'ticketPage',
          detail: err.response.data.responseParameter
        });
      });
  }

  sendData() {
    showProgressMessage();
    const urlParams = new URLSearchParams(this.props.location.search);
    var key = urlParams.get('info');
    key = key !== null ? key : '';
    axios.post(process.env.REACT_APP_BACKEND_URL + 'api/v1/io', {
      info: decodeURIComponent(key),
      hostUrl: window.location.protocol + '//' + window.location.host
    })
      .then((response) => {
        this.setState({
          page: response.data.landing,
          detail: response.data.responseParameter
        });
      })
      .catch((err) => {
        this.setState({
          page: 'ticketPage',
          detail: err.response.data.responseParameter
        });
      });
  }

  render() {
    hideProgressMessage();

    if (!this.state.page) {
      return <div />;
    }
    if (this.state.page === 'ticketPage') {
      return (
        <>
          <Helmet><title>{email.optin.ui.html.head.title.error.eng}</title></Helmet>
          <ErrorTemplate detail={this.state.detail} />
        </>
      );
    }

    if (this.state.page === 'emailOptoutConfirmation') {
      return (
        <>
          <Helmet><title>{email.optin.ui.html.head.title.optout.confirmation.eng}</title></Helmet>
          <OptoutConfirmationTemplate detail={this.state.detail} />
        </>
      );
    }

    if (this.state.page === 'emailOptoutLanding') {
      return (
        <>
          <Helmet><title>{email.optin.ui.html.head.title.optout.landing.eng}</title></Helmet>
          <OptoutTemplate sendData={this.sendData} />
        </>
      );
    }

    if (this.state.page === 'emailAlreadyOptout') {
      return (
        <>
          <Helmet><title>{email.optin.ui.html.head.title.optout.landing.eng}</title></Helmet>
          <OptoutAlreadyTemplate />
        </>
      );
    }

    if (this.state.page === 'emailAlreadyOptin') {
      return (
        <>
          <Helmet><title>{email.optin.ui.html.head.title.optin.landing.eng}</title></Helmet>
          <OptinAlreadyTemplate />
        </>
      );
    }

    if (this.state.page === 'emailOptinLandingPressed') {
      return (
        <>
          <Helmet><title>{email.optin.ui.html.head.title.optin.landing.eng}</title></Helmet>
          <OptinLandingPressedTemplate />
        </>
      );
    }

    if (this.state.page === 'emailOptinConfirmation') {
      return (
        <>
          <Helmet><title>{email.optin.ui.html.head.title.optin.confirmation.eng}</title></Helmet>
          <OptinConfirmationPage detail={this.state.detail} />
        </>
      );
    }

    return (
      <>
        <Helmet><title>{email.optin.ui.html.head.title.optin.landing.eng}</title></Helmet>
        <OptinTemplate sendData={this.sendData} />
      </>
    );
  }
}
export default OptinLanding;
